export const END_POINT_API_START = "/api/v2/";
export const API_IP = "https://api.ipify.org/?format=json";
